export default "__VITE_ASSET__aeeHfC5v__"